import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Recuperacion from '@/views/Recuperacion.vue'
import Error from '@/views/Error.vue'
import RegistroUsuario from '@/views/RegistroUsuario.vue'
import ListaPrincipal from '@/Aplicaciones/CCD/Areas/CCD/Vistas/ListaPrincipal.vue'
import DetalleOperacion from '@/Aplicaciones/CCD/Areas/CCD/Vistas/DetalleOperacion.vue'
import GuiaReferencia from  '@/Aplicaciones/CCD/Areas/GR/Vistas/GuiaReferencia.vue'
import CambioContrasenia from '@/views/CambioContrasenia.vue'

const routes = [
  {
    path: '/:pathMatch(.*)',
    name: 'Error',
    component: Error
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Recuperacion',
    name: 'Recuperacion',
    component: Recuperacion
  },
  {
    path: '/CambioContrasenia',
    name: 'CambioContrasenia',
    component: CambioContrasenia
  },
  {
    path: '/ListaPrincipal/:estatus',
    name: 'ListaPrincipal',
    component: ListaPrincipal
  },
  {
    path: '/DetalleOperacion/:id/:estatus',
    name: 'DetalleOperacion',
    component: DetalleOperacion
  },
  {
    path:'/GuiaReferencia',
    name: 'GuiaReferencia',
    component: GuiaReferencia
  },
  {
    path:'/Registro',
    name: 'RegistroUsuario',
    component: RegistroUsuario
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
